module.exports = __webpack_public_path__ + "static/media/blockIcon.aa806b32.svg";